import React, { Component } from 'react';

import { Modal, Button } from 'react-bootstrap';

import './dialog.scss';

export class ErrorDialog extends Component {
  constructor(props) {
    super(props);

    this.state = { show: false };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.message && nextProps.message != this.props.message) {
      this.setState({ show: true });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.show != this.state.show;
  }

  onHide() {
    this.setState({ show: false });
  }

  render() {
    const { onHide, show, ...props } = this.props;

    return (
      <BaseErrorDialog
        onHide={this.onHide.bind(this)}
        show={this.state.show}
        onHide={this.onHide.bind(this)}
        {...props}
        />
    );
  }
}

export class BaseErrorDialog extends Component {
  render() {
    const { dialogClassName, message, ...props } = this.props;
    return (
      <Modal
        dialogClassName={`error-dialog dialog-primary ${dialogClassName}`}
        {...props}>

        <Modal.Body className="text-center">
          <p> <span className="fa fa-frown-o"/> </p>
          <p className="text-danger">{ message }</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide} bsStyle="primary">我知道了</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./components/dialog/ErrorDialog.js